import { CmsMeta } from '../cmsMeta';
import './CmsGreeting.css';
import { ReactNode } from 'react';
import { useTranslation } from '../../../i18n/i18n';
import { useSession } from '../../../state/session';
import { renderTemplate } from '../../utils';
import { ContentCard } from '../../ContentCard/ContentCard';
import { BonusWallet } from '../../../components/bonus/BonusWallet/BonusWallet';
import { Link } from 'react-router-dom';

type CmsGreetingProps = { title: string; children: ReactNode };
export const CmsGreeting = ({ title, children }: CmsGreetingProps) => {
	const { isLoggedIn, user } = useSession();
	const t = useTranslation().bonusPage;

	if (!isLoggedIn || !user) return <></>;
	let safeFirstname = user.firstname;
	const maxLengthSafeName = 30;
	if (safeFirstname.length > maxLengthSafeName) safeFirstname = safeFirstname.slice(0, maxLengthSafeName) + '...';

	return (
		<div className="cms-greeting">
			<ContentCard title={renderTemplate(title, { firstname: safeFirstname })}>{children}</ContentCard>
			<div className="bonus-box">
				<BonusWallet heading={t.yourBonus}></BonusWallet>
				<Link className="button" to="/bonus">
					{t.yourBonus}
				</Link>
			</div>
		</div>
	);
};

export const cmsMeta: CmsMeta = {
	description:
		'Greets a signed-in customer by first name and shows their bonus balance. Renders nothing at all when nobody is signed in, so never put anything essential inside it. Use {{firstname}} in the title.',
	example: [
		'CmsGreeting',
		{ title: 'Hallo {{firstname}}!' },
		['CmsHtml', { content: '<p>Schön, dass du wieder da bist.</p>' }],
	],
};
